import EventGridItem from './EventGridItem';

export default EventGridItem;
